import PropTypes from 'prop-types';

const wasPriceType = PropTypes.arrayOf(
  PropTypes.shape({
    end_date: PropTypes.string,
    quantity: PropTypes.number,
    value: PropTypes.number,
    start_data: PropTypes.string,
  })
);

export default wasPriceType;
